import { render, staticRenderFns } from "./Medicamentos2.vue?vue&type=template&id=c6c8edca"
import script from "./Medicamentos2.vue?vue&type=script&lang=js"
export * from "./Medicamentos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports